import { defineNuxtRouteMiddleware, useCookie } from '#app';

/**
 * Beacuse of i18n routes, we need to clean the name
 * the names usually are link en__login, login__en__default etc
 * we need to clean the name to be only the name without the locale by removing any of ar/en__ or __ar/en or __ar/en__default etc
 *
 * cases:
 *  en__login => login
 *  login__en__default => login
 *  ar__login => login
 *  login__ar__default => login
 * @param name
 */
const cleanName = (name: string) => {
  return name.replace(/(___ar|___en|___en___default|___default|___ar___default)/g, '');
};

export default defineNuxtRouteMiddleware(to => {
  const redirectCookie = useCookie('redirect_url');

  const whitelist = ['login', 'register']; // Add any other routes you want to whitelist
  const name = cleanName(to.name?.toString() ?? '');
  if (!whitelist.includes(name)) {
    redirectCookie.value = to.fullPath;
  }
});
